import React, {createContext, useContext, useState} from 'react';

const AppStateContext = React.createContext({});

export function useAppState() {
    return useContext(AppStateContext);
}

export function AppStateProvider({children}) {
    /// This is the context provider for various global data that needs to be shared between components
    const [appState, setAppState] = useState({
        currentPage: 1,
        filterPage: '',
        filters: [],
    });

    const updateAppState = newData => setAppState(prevState => ({
        ...prevState,
        ...newData
    }));

    return (
        <AppStateContext.Provider value={{appState, updateAppState}}>
            {children}
        </AppStateContext.Provider>
    );
}